import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { ModalBase } from 'core/modal-base';
import { Modal } from 'core/services/modal';

@Injectable()
export class MyAccountModal extends ModalBase {
    constructor(dialog: MatDialog, modal: Modal) {
        super(dialog, modal);
    }
}
